var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opc-curve-chart"},[_c('div',{ref:"chart",staticClass:"opc-curve-chart__canvas"}),(_vm.emptyText)?_c('div',{staticClass:"opc-curve-chart__empty text-muted"},[_vm._v(_vm._s(_vm.emptyText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }